import React from "react";
import { useTrafficShaping } from "./TrafficShapingList.hooks";

const TrafficShapingContext = React.createContext<ReturnType<
  typeof useTrafficShaping
> | null>(null);

export function useTrafficShapingView() {
  const contextValue = React.useContext(TrafficShapingContext);
  if (!contextValue) {
    throw Error("Should be used inside the TrafficShapingProvider");
  }
  return contextValue;
}

export const TrafficShapingProvider = TrafficShapingContext.Provider;
